// extracted by mini-css-extract-plugin
export default {"tableActionsTitle":"app-react-components-datatables-ActionsMenuTitle-module__table-actions-title"};